import React, {forwardRef, useEffect, useMemo} from 'react';

import {ButtonBase, MenuItem, Slide, Stack} from '@mui/material';

import {yupResolver} from '@hookform/resolvers/yup';

import lineups from 'assets/lineups/home';
import {Dialog, SaveButton, Text} from 'components';
import {useTranslation} from 'hooks';
import {useLayoutStore, useSnackbarStore} from 'store';

import {schema, useApiAdd} from './useTeamApi.js';

import {Form, FormField, SelectField, useForm} from 'form';

const styles = {
    button: {
        color: 'white.main',
        marginLeft: 4,
        fontSize: '16px'
    }
};

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});

const CreateDialog = ({client, onClose, onSave, type}) => {
    const translate = useTranslation();
    const setShowLoading = useLayoutStore((state) => state.setShowLoading);
    const showInfo = useSnackbarStore((state) => state.show);
    // const translate = useTranslation();

    const {add, loading, data, errors} = useApiAdd();

    const doCancel = () => {
        onClose && onClose();
    };

    const doSave = async (formData) => {
        if (!client?.id) {
            showInfo(translate('board.lineup.choose_club'), {severity: 'warning'});
            return;
        }

        formData.client_id = client.id;
        // set the type (home/guest) if provided in the props
        if (type) {
            formData.type = type === 'home' ? 'home' : 'guest';
        }

        try {
            const res = await add(formData);
            onSave && onSave(res);
        } catch (e) {
            showInfo(e.message, {severity: 'warning'});
        }
    };

    useEffect(() => {
        setShowLoading(loading);
        return () => {
            setShowLoading(false);
        };
    }, [loading, setShowLoading]);

    const formData = useMemo(() => ({
        ...data,
        type: type && type === 'home' ? 'home' : 'guest'
    }), [data, type]);

    const rhf = useForm(formData, errors, true, {resolver: yupResolver(schema)});

    return <Dialog
        maxWidth={false}
        pt={0}
        open={true}
        TransitionComponent={Transition}
        handleClose={onClose}
        title="team.action.create2"
    >
        <Form methods={rhf.methods} onSubmit={doSave}>
            <Stack direction="column" p={2}>
                <FormField name="name" label="team.name" autoFocus/>
                <FormField name="num_players" type="number" label="team.prefs.player.count"/>
                <SelectField label="board.lineup.lineup" name="lineup">
                    {lineups.map(lineup => <MenuItem key={lineup.name} value={lineup.name}>{lineup.name}</MenuItem>)}
                </SelectField>
                
                <Stack sx={styles.fieldContainer}>
                    <SelectField label="board.lineup.display" name="type">
                        <MenuItem
                            disabled={type && type !== 'home'}
                            key={'home'}
                            value={'home'}>{translate('board.lineup.value.team')}
                        </MenuItem>
                        
                        <MenuItem
                            disabled={type && type === 'home'}
                            key={'guest'}
                            value={'guest'}>{translate('board.lineup.value.opponent')}
                
                        </MenuItem>
                        
                    </SelectField>
                </Stack>
                <Stack direction="row" justifyContent="flex-end" pb={1} pt={2}>
                    <ButtonBase disableRipple sx={styles.button} onClick={doCancel}>
                        <Text>ui.actions.cancel</Text>
                    </ButtonBase>
                    <SaveButton type="submit" ml={3} mt={0} mb={0} />
                </Stack>
            </Stack>
        </Form>
    </Dialog>;
};

export default CreateDialog;